// DB ENUM fr.gestionpial.GestionPialRight generated by ic2 no-version-available at Thu Oct 01 15:16:31 UTC 2026

import { mapping } from '@ic2/ic2-lib';

export class GestionPialRight {
  static readonly enum: boolean = true;
  static readonly __ic2_fqn: string = 'fr.gestionpial.GestionPialRight';

  constructor(public id: number, public lib: string, public name: string) {
  }

  static readonly ADMIN = new GestionPialRight(1, "Admin", "ADMIN");
  static readonly CREATEUR = new GestionPialRight(2, "Créateur", "CREATEUR");
  static readonly CORRECTEUR = new GestionPialRight(3, "Correcteur", "CORRECTEUR");

  static readonly values = [
    GestionPialRight.ADMIN,

    GestionPialRight.CREATEUR,

    GestionPialRight.CORRECTEUR

  ];

  public toString(): string {
    return this.lib;
  }
  public static map(name: string) {
    for (const e of GestionPialRight.values)
      if (e.name === name)
        return e;
    return null;
  }
  public static mapFromId(id: number) {
    for (const key of GestionPialRight.values)
      if (key.id === id)
        return key;
    return null;
  }
}

mapping['fr.gestionpial.GestionPialRight'] = GestionPialRight;
